import { render, staticRenderFns } from "./TagAlertDialog.vue?vue&type=template&id=108542f7&scoped=true&"
import script from "./TagAlertDialog.vue?vue&type=script&lang=js&"
export * from "./TagAlertDialog.vue?vue&type=script&lang=js&"
import style0 from "./TagAlertDialog.vue?vue&type=style&index=0&id=108542f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108542f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
